import React from "react";

import { Text } from "@performyard/py-components";

//components
import Avatar from "../../../../../components/Avatar";
import Button from "../../../../../components/Button";
import Container from "../../../../../components/Container";
import ContentModal from "../../../../../components/Modal/Templates/ContentModal";
import Spacer from "../../../../../components/Spacer";

//hooks
import { useInternalApiUser, useMutateEmployeeActivation } from "../../../../../api/hooks";
import useToast from "../../../../../hooks/useToast";

//style
import css from "./ReactivateModal.module.scss";

type ReactivateUserModalProps = {
	isOpen: boolean;
	handleClose: () => void;
	userID: string;
};

const ReactivateUserModal = ({ isOpen, handleClose, userID }: ReactivateUserModalProps) => {
	const toast = useToast();
	const { data: user, isLoading } = useInternalApiUser(userID);

	const { mutate: activateUser, isPending: isActivating } = useMutateEmployeeActivation({
		onSuccess: () => {
			handleClose();
			toast("User Activated", { type: "success", size: "large" });
		},
	});

	if (isLoading || !user) return null;

	return (
		<ContentModal
			isOpen={isOpen}
			closeOnClickOutside
			handleClose={handleClose}
			contentClassName={css.reactivateModal}
			buttons={[
				<Button key="cancel" onClick={handleClose} size="large">
					<Text size="paragraph-3" weight="semi-bold">
						Cancel
					</Text>
				</Button>,
				<Button
					key="reactivate"
					color="green"
					onClick={() => activateUser({ employeeId: userID, activate: true })}
					size="large"
					isRequesting={isActivating}
				>
					<Text size="paragraph-3" weight="semi-bold" color="neutral-0">
						Yes, Reactivate Employee
					</Text>
				</Button>,
			]}
		>
			<Avatar id={userID} size={120} />
			<Spacer height={2} />
			<Container gap="4px">
				<Text overrideElement="span" size="paragraph-2" weight="regular" color="neutral-10">
					Reactivate
				</Text>
				<Text overrideElement="span" size="paragraph-2" weight="semi-bold" color="neutral-10">
					{user.name}
				</Text>
			</Container>
		</ContentModal>
	);
};

export default ReactivateUserModal;
